<template>
    <div class="public-hearing">
        <p class="presentation-tab__search-title">{{ text.searchTitle }}</p>
        <z-input
            name="input1"
            :placeholder="text.searchPlaceholder"
            ref="search"
            v-model="search"
            :validateOnBlur="false"
            iconName="magnifier"
            class="presentation-tab__search"
            @input="onSearch"
        />

        <public-hearing-component
            v-if="data && data.length && !search"
            :data="data"
        />

        <div v-if="search" class="public-hearing__search-results">
            <z-filelist v-if="searchResults.length">
                <z-filelist-item
                    v-for="item in searchResults"
                    :key="`${item.name}-${item.activeFrom}`"
                    :name="item.name"
                    :icon-name="`file/${item.file.type}`"
                    :file-size="item.file.size"
                    :date="item.activeFrom"
                />
            </z-filelist>
            <z-not-found v-else class="u-top-margin--xl">
                <template v-slot:image>
                    <z-image src="/images/not-found/search.svg" width="590" height="400"></z-image>
                </template>
                <template v-slot:description>
                    <z-caption size="m" decor-left decor-right><span class="u-uppercase u-xl-bold">К сожалению, ничего не найдено</span></z-caption>
                    <p class="text-size-xl u-normal">Воспользуйтесь фильтром еще раз.</p>
                </template>
            </z-not-found>
        </div>
    </div>
</template>
<script>
import { localize } from '@/utils/i18n'
import { publicHearingData } from '@/components/PublicHearingComponent/publicHearingData.js'

export default {
    name: 'public-hearing',
    data () {
        return {
            data: publicHearingData,
            text: {
                searchTitle: localize({
                    en: 'Search',
                    ru: 'Поиск'
                }),
                searchPlaceholder: localize({
                    en: 'Enter a keyword',
                    ru: 'Введите ключевое слово'
                })
            },
            search: '',
            searchResults: []
        }
    },
    methods: {
        onSearch () {
            this.searchResults = this.data.flatMap(yearGroup =>
                yearGroup.items.filter(item =>
                    item.name.toLowerCase().includes(this.search.toLowerCase())
                )
            )
        }
    }
}
</script>
